module.exports = __webpack_public_path__ + "img/r-rachel-park-366508-unsplash-min-600x395.ec6f2697.jpg";